// extracted by mini-css-extract-plugin
export default {"sender":"refundCurrency_sender__fdKeI","amount":"refundCurrency_amount__dnvlE","balance":"refundCurrency_balance__-OV67"};